import script from "./LinkHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkHandler.vue?vue&type=script&lang=ts&setup=true"

import "./LinkHandler.vue?vue&type=style&index=0&id=316c4664&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316c4664"]])

export default __exports__